export default [
  {
    name: "ALGONQUIN",
    extent: {
      xmin: 970609.0399999991,
      ymin: 1998600.1799999997,
      xmax: 1004807.9600000009,
      ymax: 2014511.3699999973,
    },
  },
  {
    name: "BARRINGTON HILLS",
    extent: {
      xmin: 1002319.4100000001,
      ymin: 1998604.8500000015,
      xmax: 1020543.5218750015,
      ymax: 2013345.789999999,
    },
  },
  {
    name: "BULL VALLEY",
    extent: {
      xmin: 961724.4400000013,
      ymin: 2045295.2199999988,
      xmax: 988992.7074999995,
      ymax: 2077143.9200000018,
    },
  },
  {
    name: "CARY",
    extent: {
      xmin: 995701.1799999997,
      ymin: 2011906.200000003,
      xmax: 1017368.1818750016,
      ymax: 2030225.7918749973,
    },
  },
  {
    name: "CRYSTAL LAKE",
    extent: {
      xmin: 959890.6600000001,
      ymin: 2011817.710000001,
      xmax: 1000892.7199999988,
      ymax: 2043515.200000003,
    },
  },
  {
    name: "FOX LAKE",
    extent: {
      xmin: 1015123.8318750001,
      ymin: 2096382.6187499985,
      xmax: 1020603.4018750004,
      ymax: 2123044.735624999,
    },
  },
  {
    name: "FOX RIVER GROVE",
    extent: {
      xmin: 1010027.6400000006,
      ymin: 2009856.5600000024,
      xmax: 1020561.1381249987,
      ymax: 2017354.240000002,
    },
  },
  {
    name: "GREENWOOD",
    extent: {
      xmin: 962435.120000001,
      ymin: 2080160.3800000026,
      xmax: 979195.3500000015,
      ymax: 2094948.289999999,
    },
  },
  {
    name: "HAMPSHIRE",
    extent: {
      xmin: 934743.55999999866,
      ymin: 1996001.4299999997,
      xmax: 942654.3518749997,
      ymax: 2002043.2393750027,
    },
  },
  {
    name: "HARVARD",
    extent: {
      xmin: 895827.1600000001,
      ymin: 2087029.9799999967,
      xmax: 920472.7699999995,
      ymax: 2112482.1099999994,
    },
  },
  {
    name: "HEBRON",
    extent: {
      xmin: 952778.6999999992,
      ymin: 2106759.0900000036,
      xmax: 960752,
      ymax: 2118585.4799999967,
    },
  },
  {
    name: "HOLIDAY HILLS",
    extent: {
      xmin: 1008654.25,
      ymin: 2046608.1300000026,
      xmax: 1015638.9499999992,
      ymax: 2054428.5700000003,
    },
  },
  {
    name: "HUNTLEY",
    extent: {
      xmin: 946631.2100000009,
      ymin: 1998646.450000003,
      xmax: 969309.5599999987,
      ymax: 2021048.8100000024,
    },
  },
  {
    name: "ISLAND LAKE",
    extent: {
      xmin: 1013155.8200000003,
      ymin: 2035927.0900000035,
      xmax: 1020763.0537500009,
      ymax: 2053119.0200000032,
    },
  },
  {
    name: "JOHNSBURG",
    extent: {
      xmin: 991551.4699999988,
      ymin: 2075220.5200000032,
      xmax: 1019295.0500000007,
      ymax: 2094049.8418750018,
    },
  },
  {
    name: "LAKE IN THE HILLS",
    extent: {
      xmin: 957474.4699999988,
      ymin: 2003972.0600000024,
      xmax: 999471.0300000012,
      ymax: 2020696.450000003,
    },
  },
  {
    name: "LAKEMOOR",
    extent: {
      xmin: 1010000.2399999984,
      ymin: 2058402.6700000018,
      xmax: 1020709.6018749997,
      ymax: 2078271.1300000026,
    },
  },
  {
    name: "LAKEWOOD",
    extent: {
      xmin: 953589.2199999988,
      ymin: 2017068.539999999,
      xmax: 980401.9750000015,
      ymax: 2035608.458750002,
    },
  },
  {
    name: "MARENGO",
    extent: {
      xmin: 894734.0375000015,
      ymin: 2023134.5006249994,
      xmax: 920284.6400000006,
      ymax: 2041664.1599999964,
    },
  },
  {
    name: "MCCULLOM LAKE",
    extent: {
      xmin: 991571.5799999982,
      ymin: 2075231.509999998,
      xmax: 997239.5500000007,
      ymax: 2079340.950000003,
    },
  },
  {
    name: "MCHENRY",
    extent: {
      xmin: 980896.6499999985,
      ymin: 2051682.9200000018,
      xmax: 1010061.7899999991,
      ymax: 2077936.0799999982,
    },
  },
  {
    name: "OAKWOOD HILLS",
    extent: {
      xmin: 1004778.370000001,
      ymin: 2030253.710000001,
      xmax: 1014210.8900000006,
      ymax: 2035952.8800000026,
    },
  },
  {
    name: "PORT BARRINGTON",
    extent: {
      xmin: 1017543.6700000018,
      ymin: 2028929.8400000035,
      xmax: 1020829.557500001,
      ymax: 2035930.549999997,
    },
  },
  {
    name: "PRAIRIE GROVE",
    extent: {
      xmin: 992771.5749999992,
      ymin: 2033152.588681293,
      xmax: 1011050.8200000003,
      ymax: 2051736.3900000006,
    },
  },
  {
    name: "RICHMOND",
    extent: {
      xmin: 985033.0500000007,
      ymin: 2102884.8999999985,
      xmax: 999528.0399999991,
      ymax: 2122845.289999999,
    },
  },
  {
    name: "RINGWOOD",
    extent: {
      xmin: 983671.7399999984,
      ymin: 2079874.1799999997,
      xmax: 998683.8200000003,
      ymax: 2093769.8200000003,
    },
  },
  {
    name: "SPRING GROVE",
    extent: {
      xmin: 997872.3299999982,
      ymin: 2092761.8699999973,
      xmax: 1018795.3099999987,
      ymax: 2122973.049999997,
    },
  },
  {
    name: "TROUT VALLEY",
    extent: {
      xmin: 1003621.8200000003,
      ymin: 2012310.3900000006,
      xmax: 1007494.2899999991,
      ymax: 2016947.3500000015,
    },
  },
  {
    name: "UNION",
    extent: {
      xmin: 924767.0100000016,
      ymin: 2022307.6599999964,
      xmax: 930783.4400000013,
      ymax: 2030408.1099999994,
    },
  },
  {
    name: "WONDER LAKE",
    extent: {
      xmin: 967732,
      ymin: 2071320.3400000035,
      xmax: 991597.2899999991,
      ymax: 2092349.3699999973,
    },
  },
  {
    name: "WOODSTOCK",
    extent: {
      xmin: 941388.5387500003,
      ymin: 2040776.6499999985,
      xmax: 970322.8200000003,
      ymax: 2072466.240000002,
    },
  },
];
